module.exports = __webpack_public_path__ + "img/rindfleischganbianseitlich.a1b72ec0.jpg";